const imageSlider = ($el) => {
    $($el).slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        dots: true,
        adaptiveHeight: true,
        lazyLoad: 'ondemand',
    });
};

export default imageSlider;
